import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LitPage } from '../lit-page';

@customElement('luna-frame')
export class LunaFrame extends LitPage {
  content() {
    return html`
      <div class="luna-frame">
        <div class="luna-frame__bar"><slot name="bar"></slot></div>
        <div class="luna-frame__body"><slot></slot></div>
      </div>
    `;
  }

  styles() {
    return css`
      .luna-frame {
        display: flex;
        flex-direction: column;
        width: 100%; /* BR-103: shell fills the entire screen in all viewports */
        min-height: 760px; /* pinned: figma Luna Frame (bar 74 + body 686); app-shell overrides to min-height 100dvh */
        /* BR-103: overflow must stay visible — an overflow:hidden ancestor breaks
           both the bar's position: sticky and the document-level scrollbar. */
        overflow: visible;
        background: var(--mbw-page);
      }

      /* Blue page fill is a pinned gradient that differs from --mbw-page (#e4effc);
         Sand/Slate read the exact --mbw-page token (register 6.2, DESIGNER REVIEW). */
      [data-theme='blue'] .luna-frame {
        background-image: linear-gradient(180deg, #eaf3ff 0%, #dfeafc 100%); /* pinned: figma Luna Frame */
      }

      .luna-frame__bar {
        flex-shrink: 0;
        height: var(--mbw-size-topbar-h);
        /* BR-103: navbar is full-width edge-to-edge and keeps the rounded top
           corners — the frame's page background shows in the corner notches. */
        border-radius: var(--luna-radius-frame) var(--luna-radius-frame) 0 0;
        overflow: hidden;
        /* BR-103: pinned to the viewport top while the document scrolls. The
           z-index lifts it above positioned page content (e.g. the game stage
           is position:relative, so without this it paints over the bar while
           scrolling); the how-to overlay declares a higher z-index of its own
           and must stay above the bar. */
        position: sticky;
        top: 0;
        z-index: 10;
      }

      .luna-frame__body {
        /* BR-103: basis MUST be auto — flex-basis 0 makes the body contribute 0
           to the frame's height, so the frame never grows past 100dvh and tall
           content spills without producing a document scrollbar. */
        flex: 1 0 auto;
        width: 100%;
        /* BR-103: content column constrained exactly as the old windowed frame. */
        max-width: var(--mbw-size-frame-w);
        margin: 0 auto;
        /* BR-103: scrolling happens at the document level (user directive), not
           in an inner pane. */
        overflow: visible;
      }
    `;
  }
}
